<template>
    <div class="queue-edit">
        <div class="queue-edit__header">
            <h5 class="queue-edit__header-title">Manage Queue Item</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div class="row">
                <div class="col-lg-8">
                    <div class="card queue-edit__card">
                        <div class="queue-edit__title"><i class="far fa-user-edit"></i> Edit Queue Item <button
                                type="button" class="btn btn-sm btn-light-warning float-right"
                                @click="closeQueueItem()">
                                <i class="far fa-times"></i> Close</button></div>
                        <div class="card-body">
                            <transition name="fade">
                                <div v-if="queueUpdateStatus">
                                    <div v-if="queueUpdateType == 'success'" class="alert alert-success" role="alert">
                                        <i class="far fa-check"></i> {{ queueUpdateMessage }}
                                    </div>
                                    <div v-else-if="queueUpdateType == 'warning'" class="alert alert-warning"
                                        role="alert">
                                        <i class="far fa-exclamation-triangle"></i> {{ queueUpdateMessage }}
                                    </div>
                                </div>
                            </transition>
                            <div v-if="!queueLoadStatus">
                                <div v-if="queueEditStatus">
                                    <form id="formEditQueueItem">
                                        <input type="hidden" name="id" id="id" v-model="queueItem.itemid">
                                        <input type="hidden" name="mode" id="mode" value="updateItem">
                                        <input type="hidden" name="department" id="department" :value="getDepartment">
                                        <input type="hidden" id="emailid" name="emailid" v-model="queueItem.emailid">
                                        <div class="form-group">
                                            <label for="name">Name</label>
                                            <input type="text" class="form-control form-control-sm" id="name"
                                                name="name" v-model="queueItem.name" aria-describedby="name"
                                                placeholder="Enter name">
                                        </div>
                                        <div class="form-group">
                                            <label for="emplid">Student Number</label>
                                            <input type="text" class="form-control form-control-sm" id="emplid"
                                                name="emplid" v-model="queueItem.emplid"
                                                aria-describedby="student number" placeholder="Enter student number"
                                                @input="getStudentNumber()">
                                        </div>
                                        <div class="form-group">
                                            <label for="username">Western Email</label>
                                            <div class="input-group input-group-sm">
                                                <input type="email" class="form-control form-control-sm" id="username"
                                                    name="username" :maxlength="8" v-model="queueItem.username"
                                                    aria-describedby="username" placeholder="Enter email"
                                                    @input="getUsernameAndEmail()">
                                                <div class="input-group-append">
                                                    <span class="input-group-text">@uwo.ca</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="program">Student Program</label>
                                            <input type="text" class="form-control form-control-sm" id="program"
                                                name="program" v-model="queueItem.program" aria-describedby="program"
                                                placeholder="Enter program">
                                        </div>
                                        <div class="form-group">
                                            <label for="counsellor">Counsellor</label>
                                            <div v-if="counsellors.length == 0" class="alert alert-warning">
                                                <i class="far fa-exclamation-triangle"></i> Counsellors could
                                                not be retrieved. Please contact your system
                                                administrator.
                                            </div>
                                            <select v-else class="form-control form-control-sm" id="counsellor"
                                                name="counsellor" v-model="queueItem.counsellor">
                                                <option value="">None</option>
                                                <option v-for="counsellor in counsellors" :key="counsellor.username"
                                                    :value="counsellor.username"> {{ counsellor.commonName }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="appointmentType">Appointment
                                                Type</label>
                                            <select v-model="queueItem.appointmentType"
                                                class="form-control form-control-sm" id="appointmentType"
                                                name="appointmentType">
                                                <option value="">None</option>
                                                <option value="inperson">In-person</option>
                                                <option value="virtual">Virtual</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label for="waitingArea">Waiting Area</label>
                                            <select class="form-control form-control-sm" id="waitingArea"
                                                name="waitingArea" v-model="queueItem.waitingArea">
                                                <option value="">Not Assigned</option>
                                                <option v-for="(waitingArea, i) in waitingAreasData" :key="i"
                                                    :value="waitingArea.value"> {{ waitingArea.label }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label class="w-100 mb-0" for="notes">Reason for visit/Additional
                                                notes</label>
                                            <small class="float-right">Remaining length: {{ maxNotesLength }}</small>
                                            <textarea class="form-control form-control-sm" id="notes" name="notes"
                                                :maxlength="256" rows="5" v-model="queueItem.notes"
                                                placeholder="Enter reason for visit and/or additional notes"></textarea>
                                        </div>
                                    </form>
                                    <div class="queue-edit__menu">
                                        <button type="button" class="btn btn-sm btn-primary mr-2"
                                            @click="setQueueItem()">
                                            <i v-if="queueUpdateLoad" class="fas fa-spinner fa-spin"></i>
                                            <i v-else class="far fa-edit"></i> Save</button>
                                    </div>
                                </div>
                                <div v-else class="alert alert-warning">
                                    <i class="far fa-exclamation-circle"></i> {{ queueEditMessage }}
                                </div>
                            </div>
                            <div v-else>
                                <div class="queue-edit__load">
                                    <i class="fas fa-spinner fa-spin fa-2x"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'queue-edit',
    props: {
        counsellors: {
            type: Array,
            required: true
        },
        itemId: {
            required: true
        },
        waitingAreasData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            queueItem: {
                appointmentType: '',
                counsellor: '',
                emailid: '',
                emplid: '',
                itemid: '',
                name: '',
                notes: '',
                number: '',
                program: '',
                username: '',
                waitingArea: ''
            },
            queueLoadStatus: true,
            queueEditMessage: '',
            queueEditStatus: true,
            queueUpdateLoad: false,
            queueUpdateMessage: '',
            queueUpdateStatus: false,
            queueUpdateType: ''
        }
    },
    methods: {
        closeQueueItem() {
            const that = this;
            let item = this.itemId;

            // Close queue item
            this.$router.push({
                path: '/ado/admin',
                params: {
                    id: this.itemid
                }
            }, function () {
                that.setHighlightedItem(`item${item}`);
            })
        },
        getQueueItem() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getItem&id=${this.itemId}&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Found
                    if (json.result.match(/^OK/i)) {
                        // Store item
                        that.queueItem = json.item;

                        // Default counsellor
                        that.queueItem.counsellor = that.queueItem.counsellor || '';
                        that.queueItem.waitingArea = that.queueItem.waitingArea || '';
                    } else {
                        // Set fail message and status
                        that.queueEditMessage = 'The queue item could not be found. Please refresh and try again.';
                        that.queueEditStatus = false;
                    }

                    // Set status
                    that.queueLoadStatus = false;
                })
                .catch(function (error) {
                    // Set fail message and status
                    that.queueEditMessage = 'The queue item could not be found. Please contact your system administrator.';
                    that.queueEditStatus = false;
                    that.queueLoadStatus = false;
                })
        },
        getStudentNumber() {
            let studentNumber = this.queueItem.emplid;
            studentNumber = studentNumber.replace(/\D/g, '');
            studentNumber = studentNumber.match(/^\d{0,9}/);

            // Set student number
            this.queueItem.emplid = studentNumber[0] || '';
        },
        getUsernameAndEmail() {
            this.queueItem.username = this.queueItem.username.toLowerCase();
            this.queueItem.emailid = this.queueItem.username + '@uwo.ca';
        },
        setHighlightedItem(item) {
            setTimeout(function () {
                let element = document.getElementById(item);

                if (element) {
                    element.classList.add("queue__item-highlight");
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });

                    setTimeout(function () {
                        element.classList.remove("queue__item-highlight");
                    }, 2500);
                }
            }, 1000);
        },
        setQueueItem() {
            const that = this;
            let item = this.itemId;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl`;
            const formRef = document.getElementById('formEditQueueItem');
            const formData = new FormData(formRef);

            // Set load icon status
            this.queueUpdateLoad = true;

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Success
                if (json.result.match(/ok/i)) {
                    // Alert type and message
                    that.$router.push({
                        path: '/ado/admin'
                    }, function () {
                        that.setHighlightedItem(`item${item}`);
                    })
                } else {
                    // Alert type and message
                    that.queueUpdateType = 'warning';
                    that.queueUpdateMessage = 'The Queue item could not be updated. Please try agian.';
                }

                // Toggle alert message
                that.queueUpdateLoad = false;
                that.queueUpdateStatus = true;
            }).catch(function (error) {
                // Alert type and message
                that.queueUpdateType = 'warning';
                that.queueUpdateMessage = 'The Queue item could not be updated. Please contact your system administrator.';
                that.queueUpdateStatus = true;
            })
        }
    },
    computed: {
        getDepartment() {
            // Return resolved department
            return DEPARTMENT;
        },
        getRequiredFields() {
            // Submission required fields
            if (this.queueItem.name && this.queueItem.emplid.length == 9 && this.queueItem.emailid && this.queueItem
                .username) {
                return false;
            }

            return true;
        },
        maxNotesLength() {
            // Limit max notes field length
            if (this.queueItem.notes && this.queueItem.notes.length) {
                return 256 - this.queueItem.notes.length;
            }

            return 256;
        }
    },
    mounted() {
        // Retrieve queue item info
        if (this.itemId) {
            // Retrieve queue item
            this.getQueueItem();
        } else {
            // Redirect to dashboard
            this.$router.push({
                path: '/ado/admin'
            })
        }
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.icon__warning {
    color: #ffb822;
}

.modal-body {
    font-size: 14px;
}

.modal-title {
    font-weight: 600;
    font-size: 1rem;
    color: #48465b;
}

.queue-edit__card {
    border: none;
    color: #595d6e;
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
}

.queue-edit__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.queue-edit__menu {
    text-align: right;
}

.queue-edit__header-title {
    font-weight: 600;
    margin: 0;
}

.queue-edit__load {
    color: #5d78ff;
    text-align: center;
}

.queue-edit__title {
    border-bottom: 1px solid #ebedf2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    padding: 16px 20px;
}
</style>